import NextArrowSVG from 'www/svg-icons/next-arrow';
import PreviousArrowSVG from 'www/svg-icons/previous-arrow';
import { PaginationNavigation } from 'www/modules/pagination/navigation';
import { Dictionary } from '../common/dictionary';
export class FastFiveNavigation extends PaginationNavigation{
	constructor(el){
		super(el);
		el.classList.add("promos-navigation");
	
	}
	init(){
		super.init()
		let prevLink = this.previousLinkEl;
		let nextLink = this.nextLinkEl;
		
		const locale = window.locale || 'us';
        
        let labelPrevText = Dictionary.previous[locale]; 
        let labelNextText = Dictionary.next[locale];
		
		let prevText = this.createSpanContainer(labelPrevText.toUpperCase());
		let nextText= this.createSpanContainer(labelNextText.toUpperCase());
		
		let prevContainer = this.createContainer(prevLink);
		let nextContainer = this.createContainer(nextLink);

		prevContainer.classList.add("previous-button-container");
		nextContainer.classList.add("next-button-container");

		prevLink.innerHTML = '';
		prevLink.appendChild(prevText);
		prevLink.insertAdjacentElement("afterbegin",PreviousArrowSVG.useSprite);
		
		nextLink.innerHTML = '';
		nextLink.appendChild(nextText);
		nextLink.insertAdjacentElement("beforeend",NextArrowSVG.useSprite);


		while(this.el.hasChildNodes()){
			this.el.removeChild(this.el.lastChild);
		}

		this.el.appendChild(prevContainer);
		this.el.appendChild(nextContainer);
	}

	createSpanContainer(text){
		let spanNode = document.createElement('span');
		spanNode.innerHTML = text;
		return spanNode;
	}

	createContainer(link){
		let container = document.createElement('div');
		container.classList.add('nav-button-container');
		container.appendChild(link);
		return container;
	}


}
